import { S } from '../../utils/constants';

/**
 * Reusable Modal wrapper
 * @param {string} title - Modal title
 * @param {boolean} isOpen - Visibility state
 * @param {function} onClose - Close handler
 * @param {ReactNode} children - Modal content
 * @param {string} size - 'sm' | 'md' | 'lg' | 'xl'
 */
export function Modal({ title, isOpen, onClose, children, size = 'md' }) {
  if (!isOpen) return null;

  const sizes = {
    sm: { maxWidth: 400 },
    md: { maxWidth: 600 },
    lg: { maxWidth: 800 },
    xl: { maxWidth: 1000 },
  };

  return (
    <div 
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.8)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        padding: 20,
        animation: "fIn 0.2s ease",
      }}
      onClick={onClose} // Close on backdrop click
    >
      <div 
        style={{
          background: S.card,
          borderRadius: 20,
          ...sizes[size],
          width: "100%",
          maxHeight: "90vh",
          overflow: "auto",
          border: `1px solid ${S.border}`,
          boxShadow: "0 40px 80px rgba(0,0,0,0.5)",
        }}
        onClick={e => e.stopPropagation()} // Prevent close on content click
      >
        {/* Header */}
        <div style={{
          padding: 24,
          borderBottom: `1px solid ${S.border}`,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}>
          <h2 style={{ 
            color: S.txt, 
            fontSize: 20, 
            fontWeight: 900, 
            margin: 0 
          }}>
            {title}
          </h2>
          <button
            onClick={onClose}
            style={{
              background: "transparent",
              border: `1px solid ${S.border}`,
              borderRadius: 8,
              padding: "8px 12px",
              color: S.muted,
              cursor: "pointer",
              fontSize: 18,
              fontFamily: "'Cairo',sans-serif",
            }}
          >
            ✕
          </button>
        </div>

        {/* Content */}
        <div style={{ padding: 24 }}>
          {children}
        </div>
      </div>
    </div>
  );
}
